/*
  Whether the Upgrade button is available for a subscription. Stripe subscriptions renew whatever
  their interval, so a yearly one can be upgraded like a monthly one; the credit for the unused
  time is applied by Stripe and nothing is refunded. A record with no billing cycle is a one-off
  payment, not a subscription, and has nothing to upgrade.
*/
export function canUpgradeSubscription(sub) {
  if (!sub) return false;
  const status = String(sub.status || '').toLowerCase();
  return status === 'active' && (sub.billingCycle === 'monthly' || sub.billingCycle === 'yearly');
}
